import React from 'react';
import { CheckCircleOutlined, CloseOutlined, ErrorOutlined } from '@mui/icons-material';
export const SyncProgressCompleteLayout = (props) => {
    const { isNoNewData, isError, closeClicked } = props;
    if (isError) {
        return (React.createElement("div", { style: { display: 'flex' } },
            React.createElement(CloseOutlined, { onClick: closeClicked }),
            React.createElement(ErrorOutlined, { style: { color: 'red', marginRight: '25px' } }),
            " ",
            React.createElement("div", null, "Error retrieving patient report")));
    }
    else {
        return isNoNewData ? (React.createElement("div", { style: { display: 'flex' } },
            React.createElement(CheckCircleOutlined, { style: { color: '#2E7D32', marginRight: '25px' } }),
            " ",
            React.createElement("div", null, "No New Reports To Show"))) : (React.createElement("div", { style: { display: 'flex' } },
            React.createElement(CheckCircleOutlined, { style: { color: '#2E7D32', marginRight: '25px' } }),
            " ",
            React.createElement("div", null, "Manual Sync Complete")));
    }
};
